const formatAirlinesAutocompleteResults = (filters) => [{
  label: '',
  suggests: filters
    ? filters
      .carriers
      .map((item) => ({ label: item.name, value: item.code }))
    : [],
  value: '0',
}];

export default formatAirlinesAutocompleteResults;
